const BASE_URL = `/Progress`

/*----- Total Section Progress Calls -----*/

export const getEventManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })

        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getEventBadgesManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgesManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getExtraBadgesManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getGuestBadgeManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestBadgeManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getBadgeToERSPropertyGuestMappingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveBadgeToERSPropertyGuestMappingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getRegistrantToGuestMappingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveRegistrantToGuestMappingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getGuestBadgeTemplateStylingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestBadgeTemplateStylingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getGuestBadgeTemplateFieldOrderingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestBadgeTemplateFieldOrderingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getKioskSetupManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskSetupManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

/*----- Event Managment Progress Calls -----*/

export const getRegistrantsLoadedProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveRegistrantsLoadedProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })

        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getEventFilteringProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventFilteringProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })

        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getViewGeneratedProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveViewGeneratedProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })

        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getWebhookSetupProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveWebHooksProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getPostToERSProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrievePosttoERSProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

/*----- Event Badges Progress Calls -----*/

export const getEventBadgesMappingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgesMappingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getTemplateManagmentProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveTemplateManagmentProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getRegistrationTypeMappingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveRegistrationTypeMappingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getQrCodeLogicProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQrCodeLogicProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getImageProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveImageProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getFieldOrderingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveFieldOrderingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

/*----- Extra Badges Progress Calls -----*/

export const getExtraBadgesSetupProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesSetupProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getExtraBadgesTemplateProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesTemplateProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getExtraBadgesFieldOrderingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesFieldOrderingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}


export const getExtraBadgesStaticFieldProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesStaticFieldProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

/*----- Kiosk Progress Calls -----*/

export const getKioskSettingProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskSettingProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getEditScreenProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEditScreenProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getLandingPageProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLandingPageProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}

export const getScannerPageProgress = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveScannerPageProgress`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}